import fire from '@store/firebase';

import { updateImgAndGetURL } from '@store/firebase/storage';
import { CollectionPath } from '@typings/collections.enum';
const firestore = fire.firestore();

// -----------------------------------------------------------------
//                              스킬 편집
// -----------------------------------------------------------------
export type IUpdateProps = {
  collectionPath: string;
  docId?: string;
  data: any;
  fileList: {
    selectedFile?: File | null;
    prevImgURL?: string | null | undefined;
  };
};

export async function updateSkillItem({
  collectionPath,
  docId,
  data,
  fileList,
}: IUpdateProps) {
  const ref = firestore.collection(collectionPath);
  const { selectedFile, prevImgURL } = fileList;

  if (!docId) {
    //추가
    const docId = await ref.add(data).then((res) => res.id);
    return ref.doc(docId).set({ id: docId }, { merge: true });
  }

  const imgURL = await updateImgAndGetURL({
    selectedFile: selectedFile,
    prevImgURL: prevImgURL,
    collectionPath: `${collectionPath}`,
  });

  if (docId) {
    //수정
    const rawData = { ...data, imgURL };
    // Firebase는 undefined 값을 허용하지 않으므로 제거
    const newData = Object.fromEntries(
      Object.entries(rawData).filter(([, v]) => v !== undefined),
    );

    return ref
      .doc(docId)
      .set(newData, { merge: true })
      .catch((err) => console.log(err.message));
  }
}

// -----------------------------------------------------------------
//                             스킬 지급
// -----------------------------------------------------------------
type IpresentProps = {
  collectionPath?: string;
  docId: string; // photocardID
  skillIDList: string[];
};
export function presentSkill({
  collectionPath,
  docId,
  skillIDList,
}: IpresentProps) {
  const _collectionPath = collectionPath || CollectionPath.PHOTOCARD;
  const ref = firestore.collection(
    `${_collectionPath}/${docId}/${CollectionPath.SKILLS}`,
  );

  return Promise.all(
    skillIDList.map(async (itemId) => {
      // skills의 docID를 skill itemID 와 통일
      return ref.doc(itemId).set(
        {
          originItemID: itemId,
          skillId: itemId,
          createdAt: new Date(),
          __snapshot: '',
        },
        { merge: true },
      );
      // promise 완료 -----------------------------------
    }),
  ).catch((err) => {
    alert(err.message);
    throw err;
  });
}

// -----------------------------------------------------------------
//                             유저의 스킬 삭제
// -----------------------------------------------------------------
export function removeSkill({ collectionPath, docId, skillId }) {
  const _collectionPath = collectionPath || CollectionPath.PHOTOCARD;
  const ref = firestore.collection(
    `${_collectionPath}/${docId}/${CollectionPath.SKILLS}`,
  );

  return ref.doc(skillId).delete();
}

// -----------------------------------------------------------------
//                             유저의 장비 삭제
// -----------------------------------------------------------------
export function removeEquipment({ collectionPath, docId, equipId }) {
  const _collectionPath = collectionPath || CollectionPath.PHOTOCARD;
  const ref = firestore.collection(
    `${_collectionPath}/${docId}/${CollectionPath.EQUIPMENT}`,
  );

  return ref.doc(equipId).delete();
}
